import { render, staticRenderFns } from "./EditProductPickupLocation.vue?vue&type=template&id=147c1d37&scoped=true"
import script from "./EditProductPickupLocation.vue?vue&type=script&lang=js"
export * from "./EditProductPickupLocation.vue?vue&type=script&lang=js"
import style0 from "./EditProductPickupLocation.vue?vue&type=style&index=0&id=147c1d37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c1d37",
  null
  
)

export default component.exports